import type { ManagedBlockGoal } from './types';

export const DEFAULT_GOAL: ManagedBlockGoal = 'executive-summary';

export const isGoal = (value: unknown): value is ManagedBlockGoal =>
	value === 'decision-register' ||
	value === 'executive-summary' ||
	value === 'meeting-recap' ||
	value === 'system-design';
